"use strict";
/**
 * @file Created on 03/03/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationLockDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastSimulationLockDTOConverter, _DataObjectConverter_);

  function ForecastSimulationLockDTOConverter() {
    _classCallCheck(this, ForecastSimulationLockDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationLockDTOConverter).apply(this, arguments));
  }

  return ForecastSimulationLockDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastSimulationLockDTOConverter = ForecastSimulationLockDTOConverter;